<template>
  <div class="c-box p-menus-no-detail">
    <div
      class="p-menus-no-detail__header"
      v-if="menu && menu.menuIcons && menu.menuIcons.length > 0"
    >
      <ul class="p-menus-no-detail__header__bene-status">
        <template v-for="item in menu.menuIcons">
          <li :key="item.id" v-if="item.isAvailable">
            {{ item.iconNm }}
          </li>
        </template>
      </ul>
    </div>
    <div class="p-menus-no-detail__contents">
      <div class="p-menus-no-detail__contents__left">
        <!-- PC時はスライダー -->
        <BasicCarousel
          :images="viewPhotoList"
          :isShowIndicator="false"
          :numberThumbnail="5"
          :isRoomImage="true"
        />
        <!-- <MenusSlider
          class="c-displayPc"
          :photoList="viewPhotoList"
          :opt="{ thumbnail: 1 }"
        /> -->
        <!-- SP時は横スクロール -->
        <!-- <div class="c-displaySp">
          <ul class="p-menus-no-detail__slide-carousel">
            <li
              class="p-menus-no-detail__slide-carousel__item"
              v-for="(item, i) in viewPhotoList"
              :key="i"
            >
              <img :src="item.imageUrl" :alt="item.description" />
            </li>
          </ul>
        </div> -->
      </div>
      <div class="p-menus-no-detail__contents__right">
        <MenusLifeSummary :menu="menu" />
        <div v-if="isB35SrvDiv">
          <div class="equipment">
            <div
              v-if="equipServices && equipServices.length"
              class="equipment-item"
            >
              <div class="equipment-item-title">
                <span v-if="dataBudget && dataBudget.length">
                  {{ dataBudget[0].equipServNm1 }}
                </span>
              </div>
              <div class="equipment-item-content">
                <div
                  v-if="
                    displayEquipValue(equipServices[0], 'lunch') &&
                      displayEquipValue(equipServices[0], 'lunch') != ''
                  "
                  class="left"
                >
                  <Icon name="sun" class="icon" /><span
                    v-html="displayEquipValue(equipServices[0], 'lunch')"
                  ></span>
                </div>
                <div
                  v-if="
                    displayEquipValue(equipServices[0], 'dinner') &&
                      displayEquipValue(equipServices[0], 'dinner') != ''
                  "
                  class="right"
                >
                  <Icon name="moon" class="icon" />
                  <span
                    v-html="displayEquipValue(equipServices[0], 'dinner')"
                  ></span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="detail-genre"
            v-if="
              (
                equipServices[0] || { equipServDetail1: [] }
              ).equipServDetail1.find((i) => i.equipServCd1 === 'genre')
            "
          >
            <span>ジャンル</span>
            {{ displayValueOfType(equipServices[0], "genre") }}
          </div>
        </div>
      </div>
    </div>

        <!-- インフォメーション -->
    <div
      class="p-menus-no-detail__block"
      v-if="menu && menu.menuInfomation && menu.menuInfomation.length > 0"
    >
      <h3 class="p-menus-no-detail__block__title c-title2">
        インフォメーション
      </h3>
      <MenusInfomation :menuNo="queryCode.menuNo" :menu="menu" />
    </div>

    <!-- おすすめプラン -->
    <div
      class="p-menus-no-detail__block"
      v-if="
        Object.keys(plan).length > 0 &&
          (menu.menuBasicInfo.srvicDiv != CONST_DATA.SRVIC_DIV.ENTERTAINMENT ||
            (menu.menuBasicInfo.srvicDiv == CONST_DATA.SRVIC_DIV.ENTERTAINMENT &&
              menu.headerData.recommendation))
      "
    >
      <h3 class="p-menus-no-detail__block__title c-title2">おすすめプラン</h3>
      <!--  興行以外    -->
      <MenusPlanBlock
        :menu="menu"
        :menuNo="queryCode.menuNo"
        :recommend="1"
        :plan="arrPlans"
        :planDetails="arrPlansDetails"
        :usageDiv="usageDiv"
        v-if="menu && menu.menuBasicInfo.srvicDiv != CONST_DATA.SRVIC_DIV.ENTERTAINMENT"
      />

      <!--  興行    -->
      <MenusExhibition
        :menuNo="queryCode.menuNo"
        :recommend="1"
        :plan="plan"
        :iconCd="iconCd"
        :recommendationPlanData="menu && menu.headerData.recommendation"
        :seatType="getSeatType()"
        v-if="menu && 
          menu.menuBasicInfo.srvicDiv == CONST_DATA.SRVIC_DIV.ENTERTAINMENT &&
            menu.headerData.recommendation
        "
      />

      <div class="p-menus-no-detail__block__link"
           :class="{'flex_block_link': menu && menu.menuBasicInfo.srvicDiv != CONST_DATA.SRVIC_DIV.ENTERTAINMENT}"
      >
        <p class="p-paginator__label"
           v-if="menu && menu.menuBasicInfo.srvicDiv != CONST_DATA.SRVIC_DIV.ENTERTAINMENT"
        >
          {{ lengthPlans }}
        </p>
        <router-link
          :to="
            `/dp/menus/${queryCode.menuNo}/plans`
          "
          class="c-text-button c-text-button--sm c-text-button--right"
        >
          プラン一覧を見る
          <Icon
            name="arrow_right"
            width="33px"
            height="48px"
            :color="'#DA291C'"
          />
        </router-link>
      </div>
    </div>

    <!-- 店舗情報 -->
    <template
      v-if="
        isOnlyFacilities && menu &&
          menu.menuBasicInfo.srvicDiv != CONST_DATA.SRVIC_DIV.ENTERTAINMENT
      "
    >
      <LoadingContent v-if="isLoading.area" />
      <div v-else  class="p-menus-no-detail__block">
        <h3 class="p-menus-no-detail__block__title c-title2">店舗情報</h3>
        <MenusStoreInfo :store="storeInfo" :menu="menu && menu.headerData" />
      </div>
    </template>

    <template
      v-if="
        isOnlyFacilities && menu &&
          menu.menuBasicInfo.srvicDiv != CONST_DATA.SRVIC_DIV.ENTERTAINMENT
      "
    >
      <div
        v-if="dataEquipServiceDetail && dataEquipServiceDetail.length"
        class="p-menus-no-detail__block"
      >
        <h3 class="p-menus-no-detail__block__title c-title2">
          {{ equipServices[0].equipServTitleNm }}
        </h3>
        <div class="equip-serv-detail">
          <div
            v-for="(item, i) in dataEquipServiceDetail"
            :key="i"
            class="equip-serv-detail-item"
          >
            <div class="equip-serv-detail-left">{{ item.equipServNm1 }}</div>
            <div class="equip-serv-detail-right">
              {{ item.equipServValue1 }}
            </div>
          </div>
        </div>
        <div v-if="equipServices[0].equipServNote" class="equip-serv-note">
          {{ equipServices[0].equipServNote }}
        </div>
      </div>
    </template>

    <!-- 設備・サービス情報 -->
    <template v-if="isOnlyFacilities || isNoFacilities">
      <MenusFacilityService :facility="facilityInfo" />
    </template>

       <!-- 店舗一覧 -->
    <template v-if="isMultiFacilities">
      <LoadingContent v-if="isLoading.store" />
      <MenusStoreList
        v-else
        :areaList="areaFacilities"
        :pagingList="pagingList"
        :menu="menu"
        :size="pageSize"
        @pageChange="pageChange($event)"
        @clickMidArea="onClickMidArea"
      />
    </template>

    <!-- サービス対象エリア -->
    <template v-if="isNoFacilities">
      <MenusServiceAreaList :serviceArea="serviceArea" />
    </template>

    <!-- 注意事項 -->
    <template v-if="isOnlyFacilities">
      <p class="p-menus-no-detail__attention">
        ［注意事項］
        店舗情報については、更新時点での情報となり、サービス提供企業の都合により現状の情報が異なる場合があります。
      </p>
      <p v-if="storeInfo.lastUpdateDate" class="p-menus-no-detail__updateDate">
        {{ $moment(storeInfo.lastUpdateDate).format("LL") }}更新
      </p>
    </template>

    <!--  サービス提供企業情報    -->
    <template v-if="isServiceTable">
      <div class="p-menus-no-detail__block">
        <h3 class="p-menus-no-detail__block__title c-title2">
          サービス提供企業情報
        </h3>

        <MenusServiceTable :menu="menu" />
      </div>
    </template>

  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable no-irregular-whitespace */
/* eslint-disable vue/no-side-effects-in-computed-properties */
/* eslint-disable vue/no-unused-components */

import _ from 'lodash'
import get from "lodash/get";
import orderBy from "lodash/orderBy";
// import MenusSlider from '../components/MenusSlider'
import MenusLifeSummary from '../components/MenusLifeSummary'
import MenusInfomation from '../components/MenusInfomation'
import MenusPlanBlock from '../components/MenusPlanBlock'
import MenusExhibition from '../components/MenusExhibition'
import MenusStoreInfo from '../components/MenusStoreInfo'
import MenusFacilityService from '../components/MenusFacilityService'
import MenusServiceAreaList from '../components/MenusServiceAreaList'
import MenusServiceTable from '../components/MenusServiceTable'
import MenusStoreList from '../components/MenusStoreList'

export default {
  name: 'DPMenus',
  components: {
    // MenusSlider,
    MenusLifeSummary,
    MenusInfomation,
    MenusPlanBlock,
    MenusExhibition,
    MenusStoreInfo,
    MenusFacilityService,
    MenusServiceAreaList,
    MenusServiceTable,
    MenusStoreList
    
  },
  props: {
    menu: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      // menu:{},
      pageTotal: 0,
      currentPage: 1,
      pageSize: 10,
      areaList: [],
      storeList: {},
      sliderOptions: {
        paginationClickable: true,
        loop: false,
        slidesPerView: 1,
        centeredSlides: false,
        slideToClickedSlide: true,
        spaceBetween: 10,
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev"
      },
      isLoading: {
        area: true,
        store: false
      },
      b35Extra: {}
    };
  },
  computed:{
    usageDiv(){
      return _.get(this.menu, 'headerData.usageDiv[0]', 0)
    },
    storeListFacilities() {
      return this.menu?.facilities?.facilities || [];
    },
    pagingList() {
      if (!this.storeList?.totalCount) return;
      const page = this.$route.query.page || 1;
      const facilities = this.storeList.facilities?.filter(
        (item, index) =>
          index + 1 <= page * this.pageSize &&
          index + 1 > (page - 1) * this.pageSize
      );
      return { totalCount: this.storeList.totalCount, facilities };
    },
    iconCd() {
      return get(this.menu, "headerData.iconCd[0]", null);
    },
    plan() {
      if (!this.menu || !this.menu.plans || !this.menu.plans.length) return {};
      return this.menu.plans[0];
    },
    arrPlansDetails(){
      if (!this.menu || !this.menu.planDetails || !this.menu.planDetails.length) return [];
      return this.menu.planDetails;
    },
    lengthPlans(){
      if(this.arrPlans.length > 3) return `${this.arrPlans.length}件中3件表示`
      return `${this.arrPlans.length}件中${this.arrPlans.length}件表示`
    },
    areaFacilities() {
      if (!this.areaList || !this.areaList.facilities) return [];
      return this.areaList.facilities;
    },
    arrPlans(){
      if (!this.menu || !this.menu.plans || !this.menu.plans.length) return [];
      return this.menu.plans;
    },
    equipServices() {
      return get(this.menu, "equipServices") || [];
    },
    dataEquipServiceDetail() {
      const _dataEquipServiceDetail =
        get(this.menu, "equipServices[0].equipServDetail1", null) || [];
      return _dataEquipServiceDetail.filter(
        (item) => item.equipServCd1 != "genre" && item.equipServCd1 != "budget"
      );
    },
    dataBudget() {
      const _dataBudget =
        get(this.menu, "equipServices[0].equipServDetail1", null) || [];
      return _dataBudget.filter((item) => item.equipServCd1 == "budget");
    },
    isB35SrvDiv() {
      return (
        get(this.menu, "menuBasicInfo.srvicDiv") === "B35"
      );
    },
    photoList() {
      // const photoList = this.menu.photoGallery || [];
      const photoList = this.menu?.menuBasicInfo
        ? this.menu.menuBasicInfo.menuImages
        : [];
      if (photoList.length > 0) return photoList;
      return [
        {
          imageUrl: "/cdn/images/noimage.png",
          thumb: "/cdn/images/noimage.png",
          imageExplanation: "",
          description: ""
        }
      ];
    },
    viewPhotoList() {
      if (this.photoList.length < 0) {
        return [];
      }
      return this.photoList;
    },
    queryCode() {
      return {
        category: this.$route.params.category
          ? this.$route.params.category.replace("category=", "")
          : "",
        rooms: this.$route.params.rooms
          ? this.$route.params.rooms.replace("rooms=", 1)
          : "",
        roomCnt: this.$route.params.roomCnt
          ? this.$route.params.roomCnt.replace("roomCnt=", 1)
          : "",
        numPeople: this.$route.params.numPeople
          ? this.$route.params.numPeople.replace("numPeople=", 2)
          : "",
        menuNo: this.$route.params.menuNo
          ? this.$route.params.menuNo.replace("menuNo=", "")
          : "",
        stayNights: this.$route.params.stayNights
          ? this.$route.params.stayNights.replace("stayNights=", 1)
          : "",
        adultHeadCnt: this.$route.params.adultHeadCnt
          ? this.$route.params.adultHeadCnt.replace("adultHeadCnt=", 2)
          : "",
        feeUpper: this.$route.params.feeUpper
          ? this.$route.params.feeUpper.replace("feeUpper=", 20000)
          : ""
      };
    },

    // 店舗情報が一つの場合true
    isOnlyFacilities() {
      if (!this.menu || !this.menu.facilities) return false;
      if (
        Object.keys(this.menu.facilities).length > 0 &&
        this.menu.facilities.facilities &&
        Array.isArray(this.menu.facilities.facilities) &&
        this.menu.facilities.facilities.length === 1
      ) {
        return true;
      }
      return false
    },
    storeInfo() {
      if (!this.menu || !this.menu.facilities) return {};
      return this.menu.facilities.facilities[0];
    },
    // 店舗情報が無い場合true
    isNoFacilities() {
      if (!this.menu) return false;
      if (!this.menu.facilities || !this.menu.facilities.length === 0) {
        return true;
      }
      return false;
    },
    facilityInfo() {
      if (!this.menu || !this.menu.facilities) {
        if (!this.menu.equipServices) {
          return {};
        } else {
          return this.menu;
        }
      }
      if (this.menu?.facilities?.facilities){
        return this.menu.facilities.facilities[0];
      }

      return {}  
    },
    serviceArea() {
      if (!this.menu || !this.menu.serviceAreas) return {};
      return this.menu.serviceAreas;
    },
    isServiceTable() {
      if (
        this.menu &&
        this.menu.menuBasicInfo &&
        this.menu.menuBasicInfo.srvicDiv ==
          this.CONST_DATA.SRVIC_DIV.ENTERTAINMENT &&
        this.menu.facilities &&
        Object.keys(this.menu.facilities).length > 0 &&
        this.menu.facilities.facilities &&
        Array.isArray(this.menu.facilities.facilities) &&
        this.menu.facilities.facilities.length > 0
      ) {
        return true;
      }
      return false;
    },
    storeGourmetMenus() {
      if (!this.menu || !this.menu.store || !this.menu.store.gourmetMenus)
        return [];
      return this.menu.store.gourmetMenus;
    },
    storeGourmetInfo() {
      if (!this.menu || !this.menu.store || !this.menu.store.gourmetInfomation)
        return [];
      return this.menu.store.gourmetInfomation;
    },
    facilities() {
      if (!this.menu || !this.menu.facilities) return {};
      return this.menu.facilities;
    },
    isMultiFacilities() {
      if (!this.menu || !this.menu.facilities) return false;
      if (
        Object.keys(this.menu.facilities).length > 0 &&
        this.menu.facilities.facilities &&
        Array.isArray(this.menu.facilities.facilities) &&
        this.menu.facilities.facilities.length > 1
      ) {
        return true;
      }
      return false;
    },
    menuHeaderData() {
      if (!this.menu || !this.menu.headerData) return {};
      return this.menu.headerData;
    },
  },
  async created(){},
  async mounted() {
    this.setMetaData();
    // this.$emit("currentTab", this.$enums.menu.INDEX);
    this.isLoading.area = true;
    // const areaList = await this.getAreaList();
    this.areaList = get(this.menu, "facilities.facilities",[]) || []
    this.isLoading.area = false;
    this.currentPage = this.$route.query.page
      ? this.$route.query.page
      : this.currentPage;
    this.getStoreList();
  },
  watch: {
    $route() {
      this.getStoreList();
    },
    menu() {
      this.setMetaData();
      this.getStoreList();
    },
    isMultiFacilities() {
      // const areaList = await this.getAreaList();
      this.areaList = get(this.menu, "facilities.facilities",[]) || []
    }
  },
  methods: {
    onClickMidArea(areaMidClassNm) {
      if (!this.storeList?.totalCount) return;
      const index = this.storeList?.facilities?.findIndex(
        (area) => area.areaMidClassNm == areaMidClassNm
      );
      let page = 1;
      if (index > -1) {
        page =
          Math.ceil(
            this.storeList?.facilities?.slice(0, index + 1)?.length /
              this.pageSize
          ) || 1;
      }
      this.$router.push({ path: this.$route.fullPath, query: { page: page } });
    },
    pageChange(page) {
      this.currentPage = page;
      this.getStoreList();
    },
    // =====================
    // metaデータ設定
    // =====================
    setMetaData() {
      this.$meta.setMetaDataList(this.menuHeaderData);
      this.$meta.setDocumentTitle(`メニュー「${this.menuHeaderData.menuNm}」（基本情報）`)
      this.$meta.setDocumentDesctiption(this.$meta.description);
    },
    async getAreaList() {
      // 店舗情報が複数ある時のみBFFを叩く
      if (this.isMultiFacilities) {
        const areaList = await this.$repositories("menus").getAreaList(
          this.queryCode.menuNo
        );
        return areaList.data;
      } else {
        return [];
      }
    },
        // ======================
    // 店舗一覧取得
    // ======================
    getStoreList() {
      if (!this.storeListFacilities?.length) return {};
      const groupArea = _.chain(this.storeListFacilities)
      .groupBy((item) => `${item.areaMidClassNm}／${item.areaSmlClassNm}`).value();
      let facilities = [];
      Object.keys(groupArea).forEach(function(key, index) {
        const dataSort = orderBy(groupArea[key], "zipCode", "asc");
        facilities.push(...dataSort);
    });
      this.storeList = {
        totalCount: this.storeListFacilities?.length || 0,
        facilities
      };
    },   
        /**
     * 座席の取得
     */
    getSeatType() {
      if (
        this.plan &&
        this.plan.ticketHeading &&
        this.plan.ticketHeading.seatType
      ) {
        return this.plan.ticketHeading.seatType;
      }
      return "";
    },
    displayValueOfType(equipment, type) {
      const _index = equipment?.equipServDetail1.findIndex(
        (i) => i.equipServCd1 == type
      );
      return _index > -1
        ? equipment?.equipServDetail1?.[_index].equipServValue1
        : "";
    },
    displayEquipValue(equipment, type) {
      // budget, lunch
      let html = "";
      let name = "";
      const val = [];
      equipment.equipServDetail1
        .filter((d1) => d1.equipServCd1 === "budget")
        .forEach((detail1) => {
          // name += detail1.equipServNm1;
          detail1.equipServDetail2
            .filter((d2) => d2.equipServCd2 === type)
            .forEach((detail2) => {
              val.push(`${detail2.equipServNm2}${detail2.equipServValue2}`);
            });
        });
      html = name + val.join("");
      return html;
    }
  },
}
</script>

<style lang="scss" scoped >
@import './styles.scss';
.c-text-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  user-select: none;
  background-color: transparent;
  color: #1f2021;
  vertical-align: middle;
  cursor: pointer;
  &:active {
    transform: translate(0, 1px);
  }
  &:hover {
    color: #da291c;
    text-decoration: none;
    @include mq() {
      color: #1f2021;
    }
    g {
      fill: #da291c;
    }
  }
  .c-icon {
    &:first-of-type {
      position: absolute;
      top: 50%;
      // margin-top: -0.575em;
      width: 1.325em;
      height: 1.325em;
    }
    &:not(:first-of-type) {
      margin-right: 0.25em;
      margin-left: 0.25em;
    }
  }
  &--sm {
    font-size: 0.875rem;
  }
  &--right {
    padding-right: 1.75em;
    .c-icon {
      right: 0;
    }
  }
  &--left {
    padding-left: 1.75em;
    .c-icon {
      left: 0;
    }
  }
  &--color1 {
    .c-icon {
      fill: #da291c;
    }
  }
}
.c-title2 {
  position: relative;
  padding-left: 1.5rem;
  font-size: 1.25rem;
  line-height: 1.5;
  font-weight: bold;
  &:not(:last-child) {
    margin-bottom: 1rem;
  }
  &::before {
    position: absolute;
    top: 50%;
    left: 0;
    content: '';
    display: inline-block;
    background-color: #da291c;
    border-radius: 3px;
    width: 0.75rem;
    height: 0.25rem;
    transform: translateY(-50%);
  }
  @include mq() {
    font-size: 1rem;
  }
}

</style>

